import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { Avatar, Dots } from "../ui";
import RevealCard from "./RevealCard";

export default function Reveal({ game, onNext, play }) {
  const [seen, setSeen] = useState(false);
  const i = game.revealIdx;
  const player = game.players[i];
  const last = i === game.players.length - 1;

  return (
    <div className="screen center">
      <Dots total={game.players.length} current={i} />
      <div className="pass" data-testid="pass-phone-text">
        <span className="muted">Pasa el teléfono a</span>
        <span className="pass-name"><Avatar name={player.name} size="lg" /> {player.name}</span>
      </div>
      <RevealCard key={i} player={player} onSeen={() => setSeen(true)} play={play} />
      <div className="actions">
        {seen ? (
          <button className="btn btn-primary btn-xl full pop-in" onClick={() => { setSeen(false); onNext(); }} data-testid="next-player-btn">
            {last ? "Empezar ronda" : "Siguiente jugador"} <ArrowRight size={22} />
          </button>
        ) : (
          <p className="hint">Solo {player.name} debe mirar la pantalla.</p>
        )}
      </div>
    </div>
  );
}
